import { gql } from '@apollo/client';
/**
 * @const SaleItemsCountQuery
 * @since 1.0.0
 */
export const SaleItemsCountQuery = gql `
  query SaleItemsCountQuery($input: SaleItemsCountInput) {
    saleItemsCount(input: $input)
  }
`;
